import Home from "../pages/Home/index";
import AfricanLanguageImp from "../pages/AfricanLanguageImp/Index";
import About from "../pages/About/Index";
import ContactUs from "../pages/ContactUs";
import NkenneaApi from "../pages/NkenneaiApi/Index";
import PlayGround from "../pages/PlayGround/Index";
import TextToSpeech from "../pages/PlayGround/components/TextToSpeech";
import Support from "../pages/Support/Index";
import FAQSection from "../pages/Support/components/FAQSection";
import Pricing from "../pages/Pricing/Index";
import NotFound from "../pages/NotFound";
import PrivacyPolicy from "../pages/LegalPages/PrivacyPolicy";
import Terms from "../pages/LegalPages/Terms";
import Refund from "../pages/LegalPages/Refund";
import UseCasesAndSolutions from "../pages/UseCasesAndSolutions/Index";
import IndustriesWeServe from "../pages/IndustriesWeServe/Index";
import OurServices from "../pages/OurServices/Index";

export const staticRoutes = [
  { path: "/", element: <Home /> },
  { path: "/african-language-imp", element: <AfricanLanguageImp /> },
  { path: "/about", element: <About /> },
  { path: "/use-cases-and-solutions", element: <UseCasesAndSolutions /> },
  { path: "/industries-we-serve", element: <IndustriesWeServe /> },
  { path: "/industries", element: <IndustriesWeServe /> },
  { path: "/nkenneai-api", element: <NkenneaApi /> },
  { path: "/playground", element: <PlayGround /> },
  { path: "/playground/text-to-text", element: <TextToSpeech /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/support", element: <Support /> },
  { path: "/faqs", element: <FAQSection /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/services", element: <OurServices /> },


  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-of-service", element: <Terms /> },
  { path: "/refund-policy", element: <Refund /> },
  { path: "*", element: <NotFound /> }, // 404 Page
];
